import React from 'react';
import useButtonState, {QueryDeleteButtonProps} from './state';
import CircleButton from '../circle-button';
import {RiDeleteBin4Line} from 'react-icons/ri';

const QueryDeleteButton: React.FC<QueryDeleteButtonProps> = (props) => {
  const {isLoading, handleRequest} = useButtonState(props);

  return (
    <CircleButton
      tooltip="Remover"
      icon={<RiDeleteBin4Line />}
      onClick={(e: Event) => {
        handleRequest();
        e.stopPropagation();
      }}
      loading={isLoading}
    />
  );
};

export default QueryDeleteButton;
